/* eslint-disable @typescript-eslint/no-misused-promises */
import classnames from 'classnames';
import React from 'react';
import { Button, Modal } from 'tea-component';

import type { IMilestone } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import type { IBaseProps } from '@home/types/common';

export interface ICardOperationsProps extends IBaseProps {
  milestoneOperationVisible?: boolean;
  // Milestone
  milestone?: IMilestone;
  // update Milestone的回调、update Sub-Milestone的回调
  onUpdateMilestone?: (milestoneId: string) => void;
  // update GR的回调
  onUpdateGR?: (milestoneId: string) => void;
  // delete Milestone的回调
  onDeleteMilestone?: (milestoneId: string) => void;
}

const CardOperations: React.FC<ICardOperationsProps> = (props) => {
  const {
    style,
    className,
    milestoneOperationVisible = false,
    milestone,
    onUpdateMilestone,
    onUpdateGR,
    onDeleteMilestone,
  } = props;

  const { milestone_id: milestoneId } = milestone || {};

  return (
    <div
      style={style}
      className={classnames('dbg-milestone-card-opinion', className, {
        'dbg-milestone-card-opinion--visible': milestoneOperationVisible,
      })}
    >
      <Button
        type="link"
        onClick={(e) => {
          e?.stopPropagation();
          if (!milestoneId) return;
          onUpdateMilestone?.(milestoneId);
        }}
      >
        Edit Meeting/Event
      </Button>
      <Button
        type="link"
        onClick={(e) => {
          e?.stopPropagation();
          if (!milestoneId) return;
          onUpdateGR?.(milestoneId);
        }}
      >
        Edit Milestone
      </Button>
      <Button
        type="link"
        onClick={async () => {
          if (!milestoneId) return;
          const isConfirm = await Modal.confirm({
            className: 'tea-dialog-media',
            message: 'Do you want to delete Milestone?',
            description: 'The deleted information will not be recovered.',
            okText: 'Confirm',
            cancelText: 'Cancel',
          });
          if (isConfirm) {
            onDeleteMilestone?.(milestoneId);
          }
        }}
      >
        Delete
      </Button>
    </div>
  );
};

export default CardOperations;
